import { FormValues } from '../components/external-customer-mapping/external-customer-mapping';

export const filterExternalCustomerMappings = (formValues: FormValues, search: string) => {
    if (formValues.mappings && formValues.mappings.length > 0) {
        return {
            mappings: formValues.mappings?.filter(
                mapping =>
                    mapping.accountName.toLowerCase().includes(search.toLowerCase()) ||
                    mapping.accountId.toString().includes(search.toLowerCase()) ||
                    (mapping.externalCustomerId ?? '').includes(search.toLowerCase())
            ),
        };
    } else {
        return { mappings: [] };
    }
};
